import React, { useState, useMemo, useEffect, useCallback } from "react";

import { createEditor, Transforms } from "slate";
import { withHistory } from "slate-history";
import {
  Slate,
  Editable,
  withReact,
  useSelected,
  useFocused
} from "slate-react";

import "./styles.css";

const TextEditorReadOnly = props => {
  const [value, setValue] = useState([
    {
      type: "paragraph",
      children: [{ text: "" }]
    }
  ]);
  const editor = useMemo(() => withHistory(withReact(createEditor())), []);

  //* **DADOS*****************************************************************************/

  const editorData = editorId => {
    switch (editorId) {
      // description
      case 1:
        return {
          containerClass: "description-text-editor-container-read-only"
        };
      // feedback
      case 2:
        return {
          containerClass: "feedback-text-editor-container-read-only"
        };
      // item
      case 3:
        return {
          containerClass: "item-text-editor-container-read-only"
        };
      // imported-question-description-in-modal
      case 4:
        return {
          containerClass: "imported-question-description-container-read-only"
        };

      default:
        return {
          containerClass: "description-text-editor-container-read-only"
        };
    }
  };

  useEffect(() => {
    if (
      typeof props.textContent === "string" &&
      JSON.parse(props.textContent) !== null
    ) {
      setValue(JSON.parse(props.textContent));
    }
  }, [
    props.editorType.id,
    props.itemIndex,
    props.questionId,
    props.textContent
  ]);

  //* **DADOS*****************************************************************************/

  //* **FORMATAÇÃO*****************************************************************************/

  let Leaf = ({ attributes, children, leaf }) => {
    if (leaf.bold) {
      children = <strong>{children}</strong>;
    }

    if (leaf.italic) {
      children = <em>{children}</em>;
    }

    if (leaf.underline) {
      children = <u>{children}</u>;
    }

    return <span {...attributes}>{children}</span>;
  };

  const renderLeaf = useCallback(props => <Leaf {...props} />, []);

  let Element = props => {
    const { attributes, children, element } = props;

    switch (element.type) {
      case "image":
        return <ImageElement {...props} />;
      default:
        return <div {...attributes}>{children}</div>;
    }
  };

  const renderElement = props => <Element {...props} />;

  //* **FORMATAÇÃO*****************************************************************************/

  //* **RENDER*****************************************************************************/

  return (
    <div
      className={editorData(props.editorType.id).containerClass}
      style={props.style}
    >
      <Slate
        editor={editor}
        value={value}
        onChange={newValue => setValue(newValue)}
      >
        <Editable
          readOnly
          renderElement={renderElement}
          renderLeaf={renderLeaf}
        />
      </Slate>
    </div>
  );
};

//* **RENDER*****************************************************************************/

//* **IMAGEM*****************************************************************************/

let ImageElement = ({ attributes, children, element }) => {
  const selected = useSelected();
  const focused = useFocused();
  return (
    <div {...attributes}>
      <div contentEditable={false}>
        <img
          alt=""
          src={element.url}
          className="d-block rounded"
          style={{
            maxWidth: "100%",
            maxHeight: "20em",
            boxShadow: selected && focused ? "0 0 0 3px #B4D5FF" : "none"
          }}
        />
      </div>
      {children}
    </div>
  );
};

//* **IMAGEM*****************************************************************************/

export default TextEditorReadOnly;
